import publicApiClient, { PublicCollectionPreview } from '../../../api/public';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const usePublicCollectionQuery = (collectionId: string) => {
  return useKlydoQuery<PublicCollectionPreview>({
    queryKey: ['publicCollection', collectionId],
    queryFn: () => publicApiClient.getCollection(collectionId),
    enabled: !!collectionId,
    retry: false,
  });
};

export default usePublicCollectionQuery;
